import { OnDestroy, OnInit, } from '@angular/core';
import { FormBuilder, } from '@angular/forms';
import { AssetScope, } from '@models';
import { Subject } from 'rxjs';
import { AssetCredentialValidator, getValueFor, resetForm, validatorsFor, } from '../../utils';
var UiSingleValueEditorComponent = /** @class */ (function () {
    function UiSingleValueEditorComponent(_fb) {
        this._fb = _fb;
        this.valueHintEnabled = true;
        this.AssetScope = AssetScope;
    }
    Object.defineProperty(UiSingleValueEditorComponent.prototype, "type", {
        get: function () {
            return this._type;
        },
        set: function (type) {
            this._type = type;
            if (this.formGroup && this.formGroup.get('value')) {
                resetForm(this.formGroup, 'value', this._type, this.isNewEntry, this._readonly);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(UiSingleValueEditorComponent.prototype, "readonly", {
        get: function () {
            return this._readonly;
        },
        set: function (readonly) {
            this._readonly = readonly;
            if (this._type === 'Credential' && this.formGroup && this.formGroup.get('value')) {
                resetForm(this.formGroup, 'value', this._type, this.isNewEntry, readonly, false, this.asset.externalName);
            }
        },
        enumerable: true,
        configurable: true
    });
    UiSingleValueEditorComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.formGroup = this._fb.group({
            'value': [
                getValueFor(this.asset, this.readonly),
                validatorsFor(this.asset.type, !!this.isNewEntry, this.readonly),
            ],
        }, {
            validator: AssetCredentialValidator('value', function () { return _this.type; }, function () { return _this.asset; }, function () { return _this.readonly; }),
        });
        this.credentialStoreChange$.subscribe(function (_) {
            if (_this._type === 'Credential' && _this.formGroup && _this.formGroup.get('value')) {
                resetForm(_this.formGroup, 'value', _this._type, _this.isNewEntry, _this._readonly, false);
            }
        });
    };
    UiSingleValueEditorComponent.prototype.ngOnDestroy = function () {
        this.credentialStoreChange$.complete();
    };
    return UiSingleValueEditorComponent;
}());
export { UiSingleValueEditorComponent };
